import { connect } from "react-redux";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogConfirmation, } from "../generic/dialog-confirmation/DialogConfirmation";
import { actionLandingPageLogout } from "../landing-page/actionLandingPage";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var mapState = function () { return ({
    messageLocaId: IdLoca.anotherSaveFound_loginViaFb_serverAccount_web,
    primaryBtnLocaId: IdLoca.tooltip_hud_logout_web,
    titleLocaId: IdLoca.anotherSaveFound_loginViaFb_title,
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.FacebookConnectAnotherPlayerLogout)); },
    onConfirmation: function () { return dispatch(actionLandingPageLogout()); },
}); };
export var DialogFacebookAnotherPlayerLogout = connect(mapState, mapDispatch)(DialogConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/DialogFacebookAnotherPlayerLogout.tsx
// module id = 2827
// module chunks = 3